import { render, staticRenderFns } from "./create_order.vue?vue&type=template&id=01f1e66e&scoped=true&"
import script from "./create_order.vue?vue&type=script&lang=js&"
export * from "./create_order.vue?vue&type=script&lang=js&"
import style0 from "./create_order.vue?vue&type=style&index=0&id=01f1e66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1e66e",
  null
  
)

export default component.exports